// extracted by mini-css-extract-plugin
export default {"textWrapEllipsis":"textWrapEllipsis--xZMHh","hoverEffect":"hoverEffect--VqyzQ","linkIcon":"linkIcon--BWEoi"};